import React from 'react'
import { Modal } from '@therms/atalaya'
import { LocationPassDownForm, useLocationContext } from '@therms/react-modules'

interface PassDownFormModalProps {
  closeHandler: () => void
  onComplete: () => void
  passDownId?: string
}

function PassDownFormModal({
  closeHandler,
  onComplete,
  passDownId,
}: PassDownFormModalProps) {
  const { locationId } = useLocationContext(true)

  return (
    <Modal
      closeHandler={closeHandler}
      header={passDownId ? 'Edit Pass Down' : 'Create Pass Down'}
      width="md"
    >
      <LocationPassDownForm
        passDownId={passDownId}
        locationId={locationId}
        onCancel={closeHandler}
        onComplete={() => {
          closeHandler()
          onComplete()
        }}
      />
    </Modal>
  )
}

export { PassDownFormModal }
